import { useState } from 'react';

import type { GetServerSideProps, NextPage } from 'next';

import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import DealerResult from '../components/dealers/DealerResult';
import DealersMap from '../components/dealers/DealersMap';
import RegionSelect from '../components/dealers/RegionSelect';
import MetaTags from '../components/layout/MetaTags';
import PageTitle from '../components/layout/PageTitle';
import dealersService from '../services/dealersService';
import type DealerType from '../types/DealerType';
import type RegionType from '../types/RegionType';

import styles from '../styles/DealersPage.module.scss';

export const getServerSideProps: GetServerSideProps = async () => {
  const { regions } = await dealersService.getRegions();
  const { dealers } = await dealersService.getDealers();
  return {
    props: { dealers, regions },
  };
};

interface Props {
  dealers: Array<DealerType>;
  regions: Array<RegionType>;
}

const DealersPage: NextPage<Props> = ({ dealers, regions }) => {
  const [region, setRegion] = useState<RegionType>();
  const [selectedDealer, setSelectedDealer] = useState<DealerType>();

  const handleChangeRegion = (newRegion?: RegionType) => {
    setRegion(newRegion);
  };

  const filteredDealers =
    region === undefined
      ? dealers
      : dealers.filter((dealer) => dealer.region.id == region.id);

  return (
    <div className={styles.dealersPage}>
      <PageTitle
        title="Dystrybutorzy"
        breadcrumbs={[['Strona główna', '/'], 'Dystrybutorzy']}
      />

      <MetaTags
        title={region ? `Dystrybutorzy (${region.name})` : 'Dystrybutorzy'}
      />

      <div className={styles.dealersLayout}>
        <div className={styles.dealersText}>
          <div className={styles.regionBox}>
            <RegionSelect
              regions={regions}
              onChange={handleChangeRegion}
              selectedRegion={region}
            />
          </div>

          <div className={styles.resultsInfo}>
            znaleziono: <strong>{filteredDealers.length} wyników</strong>
          </div>

          <OverlayScrollbarsComponent
            className={[styles.resultsList, 'dealersList'].join(' ')}
            options={{
              scrollbars: {
                autoHide: 'never',
              },
            }}
          >
            {filteredDealers.map((dealer) => (
              <DealerResult
                key={dealer.id}
                dealer={dealer}
                onMouseEnter={() => setSelectedDealer(dealer)}
                onMouseLeave={() => setSelectedDealer(undefined)}
              />
            ))}
          </OverlayScrollbarsComponent>
        </div>
        <div className={styles.dealersMap}>
          <DealersMap
            center={
              filteredDealers.length > 0
                ? {
                    lat: filteredDealers[0].latitude,
                    lng: filteredDealers[0].longitude,
                  }
                : { lat: region?.latitude || 0, lng: region?.longitude || 0 }
            }
            dealers={filteredDealers}
            selectedDealer={selectedDealer}
            fitBounds
          />
        </div>
      </div>
    </div>
  );
};

export default DealersPage;
